import { createFileRoute, lazyRouteComponent, notFound } from "@tanstack/react-router"
import { z } from "zod/v4"

import { INVOICE_TABS } from "@atlant/agent-contract"

import { queryKeys } from "#lib/query-keys.ts"
import { InvoiceMonthInboxDocument } from "#pages/authenticated/invoices/month/page.tsx"
import { InvoiceMonthSummariesDocument } from "#pages/authenticated/invoices/page.tsx"
import { DateConverter } from "#utils/date.ts"
import { client } from "#utils/graphql-client.ts"

const searchSchema = z.object({
  aircraftId: z.string().optional(),
  tab: z.enum(INVOICE_TABS).catch("all"),
  invoiceId: z.string().optional(),
})

export const Route = createFileRoute("/_authenticated/$slug/invoices/$period")({
  validateSearch: searchSchema,
  loaderDeps: ({ search: { aircraftId, tab } }) => ({ aircraftId, tab }),
  loader: async ({
    context: { queryClient, userInfo },
    params: { period },
    deps: { aircraftId, tab },
  }) => {
    const parsed = DateConverter.parsePeriod(period)
    if (!parsed) throw notFound()

    const { year, month } = parsed
    const title = DateConverter.formatPeriod(year, month)
    if (userInfo.state !== "LoggedIn") return { title }

    const organizationId = userInfo.me.organization.id
    const lateOnly = tab === "late"
    await Promise.all([
      queryClient.ensureQueryData({
        queryKey: queryKeys.invoices.monthSummaries(organizationId, aircraftId, year),
        queryFn: () =>
          client.request(InvoiceMonthSummariesDocument, {
            input: { organizationId, aircraftId, year },
          }),
      }),
      queryClient.ensureQueryData({
        queryKey: queryKeys.invoices.monthInbox(
          organizationId,
          aircraftId,
          year,
          month,
          lateOnly,
        ),
        queryFn: () =>
          client.request(InvoiceMonthInboxDocument, {
            input: { organizationId, aircraftId, year, month, lateOnly },
          }),
      }),
    ])
    return { title }
  },
  component: lazyRouteComponent(
    () => import("#pages/authenticated/invoices/month/page.tsx"),
    "InvoiceMonth",
  ),
})
